import { render, staticRenderFns } from "./v-banner-c.vue?vue&type=template&id=a9b00cdc&"
import script from "./v-banner-c.vue?vue&type=script&lang=js&"
export * from "./v-banner-c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports